
export class TextHelper {

    public static ConvertDecimalToTimeString(val?: any){
        if(val){
            const array = val.toString().split('.');
            if(array.length===2){
                return `${this.PadStartStringWithZeros(array[0])}:${this.PadEndStringWithZeros(array[1])}`;
            }
            if(array.length===1){
                return `${this.PadStartStringWithZeros(array[0])}:${this.PadEndStringWithZeros('0')}`;
            }
        }
        return '00:00';
    }

    public static PadStartStringWithZeros(str2Pad: string){
        if(str2Pad && str2Pad.length===1){
            return str2Pad.padStart(2,'0');
        }
        return str2Pad;
    }

    public static PadEndStringWithZeros(str2Pad: string){
        if(str2Pad && str2Pad.length===1){
            return str2Pad.padEnd(2,'0');
        }
        return str2Pad;
    }

    public static RemoveHtmlFrom(str: string): string {
        const regex = /(<([^>]+)>)/ig;
        str = str.replace(regex, "");
        // Handles an edge case left behind by the above (unclosed tags).
        return str.replace(/<[^/^>]+>/ig, "");
    }

    public static zeroPadNumber(val: number): string {
        return (val < 10) ? `0${val}` : `${val}`;
    }
}